<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <div v-else-if="this.$root.courseStatus === 'PreCourse'">
      <p>Ticket Information will become available once the course has begun.</p>
    </div>
    <div v-else-if="!this.loading && !this.errormessage && this.ticket">
      <div
        class="alert alert-info mb-3 d-none d-md-block"
        v-if="displayScouterKey"
      >
        You are viewing the Ticket Goals for
        <span class="h5">{{ supportInfo.ScouterFullName }}</span>.
        <p-button
          type="button"
          link
          size="sm"
          class="btn btn-default ml-4"
          @click="returnPage"
        >
          Return
        </p-button>
      </div>
      <div
        class="alert alert-info mb-3 d-block d-md-none"
        v-if="displayScouterKey"
      >
        <span style="font-size: 1.4em;">{{ supportInfo.ScouterFullName }}</span>
        <p-button
          type="button"
          link
          size="sm"
          class="btn btn-default ml-2"
          @click="returnPage"
        >
          Return
        </p-button>
      </div>
      <tabs
        class="d-none d-md-table-cell"
        pills
        type="primary"
        icons
        centered
        :active-tab="activeTabName"
        :value="activeTabName"
      >
        <tab-pane
          title="vision"
          key="vision"
        >
          <span slot="title">
            <div class="row align-items-center">
              <img
                style="float:left"
                :src="visionUrl"
                title="Ticket Overview & Vision"
              >
              <div class="content-heading">Vision</div>
            </div>
          </span>
          <ticket-vision
            :ticket="ticket"
            :support-info="supportInfo"
            :readonly="readonly"
            :display-scouter-key="displayScouterKey"
            :statuses="statuses"
            @ticket-updated="refreshTicket"
          />
        </tab-pane>
        <tab-pane
          title="goal1"
          key="goal1"
        >
          <span slot="title">
            <ticket-tab-header
              :tool-tip="goal0ToolTip"
              :badge-class="goal0BadgeClass"
              :badge="goal0Badge"
              :goal-name="goal0GoalName"
              :key="goal0GoalName"
            />
          </span>
          <ticket-goal
            :ticket-goal="ticket.TicketGoals[0]"
            :readonly="readonly"
            :display-scouter-key="displayScouterKey"
            :statuses="statuses"
            @ticket-updated="refreshTicket"
          />
        </tab-pane>
        <tab-pane
          title="goal2"
          key="goal2"
        >
          <span slot="title">
            <ticket-tab-header
              :tool-tip="goal1ToolTip"
              :badge-class="goal1BadgeClass"
              :badge="goal1Badge"
              :goal-name="goal1GoalName"
              :key="goal1GoalName"
            />
          </span>
          <ticket-goal
            :ticket-goal="ticket.TicketGoals[1]"
            :readonly="readonly"
            :display-scouter-key="displayScouterKey"
            :statuses="statuses"
            @ticket-updated="refreshTicket"
          />
        </tab-pane>
        <tab-pane
          title="goal3"
          key="goal3"
        >
          <span slot="title">
            <ticket-tab-header
              :tool-tip="goal2ToolTip"
              :badge-class="goal2BadgeClass"
              :badge="goal2Badge"
              :goal-name="goal2GoalName"
              :key="goal2GoalName"
            />
          </span>
          <ticket-goal
            :ticket-goal="ticket.TicketGoals[2]"
            :readonly="readonly"
            :display-scouter-key="displayScouterKey"
            :statuses="statuses"
            @ticket-updated="refreshTicket"
          />
        </tab-pane>
        <tab-pane
          title="goal4"
          key="goal4"
        >
          <span slot="title">
            <ticket-tab-header
              :tool-tip="goal3ToolTip"
              :badge-class="goal3BadgeClass"
              :badge="goal3Badge"
              :goal-name="goal3GoalName"
              :key="goal3GoalName"
            />
          </span>
          <ticket-goal
            :ticket-goal="ticket.TicketGoals[3]"
            :readonly="readonly"
            :display-scouter-key="displayScouterKey"
            :statuses="statuses"
            @ticket-updated="refreshTicket"
          />
        </tab-pane>
        <tab-pane
          title="goal5"
          key="goal5"
        >
          <span slot="title">
            <ticket-tab-header
              :tool-tip="goal4ToolTip"
              :badge-class="goal4BadgeClass"
              :badge="goal4Badge"
              :goal-name="goal4GoalName"
              :key="goal4GoalName"
            />
          </span>
          <ticket-goal
            :ticket-goal="ticket.TicketGoals[4]"
            :readonly="readonly"
            :display-scouter-key="displayScouterKey"
            :statuses="statuses"
            @ticket-updated="refreshTicket"
          />
        </tab-pane>
      </tabs>
      <div class="d-block d-md-none">
        <fg-input>
          <label class="control-label mobileLabel">Select Goal</label>
          <el-select
            class="select-default2"
            size="large"
            name="goalSelector"
            placeholder=""
            v-model="mobileComponent"
          >
            <el-option
              class="select-default2"
              value="vision"
              label="Vision"
              key="vision"
            />
            <el-option
              class="select-default2"
              value="goal1"
              :label="ticket.TicketGoals[0].GoalName"
              key="goal1"
            />
            <el-option
              class="select-default2"
              value="goal2"
              :label="ticket.TicketGoals[1].GoalName"
              key="goal2"
            />
            <el-option
              class="select-default2"
              value="goal3"
              :label="ticket.TicketGoals[2].GoalName"
              key="goal3"
            />
            <el-option
              class="select-default2"
              value="goal4"
              :label="ticket.TicketGoals[3].GoalName"
              key="goal4"
            />
            <el-option
              class="select-default2"
              value="goal5"
              :label="ticket.TicketGoals[4].GoalName"
              key="goal5"
            />
          </el-select>
        </fg-input>
        <ticket-vision
          class="d-block d-md-none"
          v-if="mobileComponent === 'vision'"
          :ticket="ticket"
          :support-info="supportInfo"
          :readonly="readonly"
          :display-scouter-key="displayScouterKey"
          :statuses="statuses"
          @ticket-updated="refreshTicket"
        />
        <ticket-goal
          class="d-block d-md-none"
          v-if="mobileComponent === 'goal1'"
          :ticket-goal="ticket.TicketGoals[0]"
          :readonly="readonly"
          :display-scouter-key="displayScouterKey"
          :statuses="statuses"
          @ticket-updated="refreshTicket"
        />
        <ticket-goal
          class="d-block d-md-none"
          v-if="mobileComponent === 'goal2'"
          :ticket-goal="ticket.TicketGoals[1]"
          :readonly="readonly"
          :display-scouter-key="displayScouterKey"
          :statuses="statuses"
          @ticket-updated="refreshTicket"
        />
        <ticket-goal
          class="d-block d-md-none"
          v-if="mobileComponent === 'goal3'"
          :ticket-goal="ticket.TicketGoals[2]"
          :readonly="readonly"
          :display-scouter-key="displayScouterKey"
          :statuses="statuses"
          @ticket-updated="refreshTicket"
        />
        <ticket-goal
          class="d-block d-md-none"
          v-if="mobileComponent === 'goal4'"
          :ticket-goal="ticket.TicketGoals[3]"
          :readonly="readonly"
          :display-scouter-key="displayScouterKey"
          :statuses="statuses"
          @ticket-updated="refreshTicket"
        />
        <ticket-goal
          class="d-block d-md-none"
          v-if="mobileComponent === 'goal5'"
          :ticket-goal="ticket.TicketGoals[4]"
          :readonly="readonly"
          :display-scouter-key="displayScouterKey"
          :statuses="statuses"
          @ticket-updated="refreshTicket"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ticketGoalStatuses from '@/services/static/ticket-goal-statuses'
import ticketGoalApi from '@/services/api/ticket'
import oops from '@/components/_main/oops.vue'
import ticketGoal from '@/components/tickets/ticket-goal.vue'
import ticketVision from '@/components/tickets/ticket-vision.vue'
import formatter from '@/services/formatter.js'
import Tabs from '@/plugins/paper-components/tabs/tabs.vue'
import TabPane from '@/plugins/paper-components/tabs/tab.vue'
import TicketTabHeader from '@/components/tickets/ticket-tab-header.vue'

export default {
  name: 'Ticket',
  components: {
    oops,
    ticketGoal,
    ticketVision,
    Tabs,
    TabPane,
    TicketTabHeader
  },
  data: function () {
    return {
      displayScouterKey: null,
      callingPage: null,
      mobileComponent: 'Vision',
      activeTabName: '1',
      statuses: null,
      ticket: null,
      originalVision: null,
      supportInfo: null,
      loading: true,
      errormessage: null,
      showPrint: false,
      printItem: false,
      goal0ToolTip: '',
      goal0BadgeClass: '',
      goal0Badge: '',
      goal0GoalName: '',
      goal1ToolTip: '',
      goal1BadgeClass: '',
      goal1Badge: '',
      goal1GoalName: '',
      goal2ToolTip: '',
      goal2BadgeClass: '',
      goal2Badge: '',
      goal2GoalName: '',
      goal3ToolTip: '',
      goal3BadgeClass: '',
      goal3Badge: '',
      goal3GoalName: '',
      goal4ToolTip: '',
      goal4BadgeClass: '',
      goal4Badge: '',
      goal4GoalName: '',
      printOptions: {
        styles: [
          '/kidlat.css',
          '/bootstrap.min.css',
          '/chalk-theme.css',
          '/printer-styles/two-beads-print.css',
          '/printer-styles/header-footer.css',
          '/printer-styles/ticket.css'
        ]
      }
    }
  },
  computed: {
    visionUrl: function () {
      return require('@/assets/bootstrap-icons/icons/flower1.svg')
    },
    readonly: function () {
      return !(
        this.$root.isAdmin ||
        this.displayScouterKey === null ||
        this.displayScouterKey === undefined
      )
    }
  },
  created: function () {
    this.statuses = ticketGoalStatuses.getStatuses()
  },
  mounted: function () {
    this.readQueryString()
    this.refreshTicket()
  },
  updated: function () {
    this.$nextTick(function () {
      if (this.printItem) {
        alert('here')
        this.$htmlToPaper('printpage', this.printOptions)
      }
      this.printItem = false
    })
  },
  methods: {
    readQueryString: function () {
      if (this.$route.query.s && this.$route.query.r) {
        this.displayScouterKey = this.$route.query.s
        if (this.$route.query.r === 'tick') {
          this.callingPage = '/staff/ticket-goals'
        } else if (this.$route.query.r === 'tick-edit') {
          this.callingPage = '/staff/ticket-goals/edit'
        }
      }
      if (this.$route.query.g) {
        this.activeTabName = 'goal' + this.$route.query.g
        this.mobileComponent = 'goal' + this.$route.query.g
      } else {
        this.activeTabName = 'vision'
        this.mobileComponent = 'vision'
      }
    },
    formatDate: function (dt) {
      return formatter.formatAsDate(dt)
    },
    refreshTicket: function () {
      const key = this.displayScouterKey ?? this.$root.scouterKey
      ticketGoalApi
        .getTicket(key)
        .then(x => {
          this.ticket = x.Ticket
          this.supportInfo = x.SupportInfo
          this.originalVision = this.ticket.Vision
          this.updateTabValues(x.Ticket)
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    onVisionBlur: function () {
      if (this.originalVision !== this.ticket.Vision) {
        ticketGoalApi
          .updateTicket(this.$root.scouterKey, this.ticket)
          .then(x => {
            this.ticket = x.Ticket
            this.supportInfo = x.SupportInfo
            this.originalVision = this.ticket.Vision
            this.updateTabValues(x.Ticket)
          })
          .catch(error => {
            console.log(error)
            this.$notify({
              message: 'There was an error updating your ticket.',
              icon: 'bi bi-exclamation-circle-fill',
              type: 'error',
              horizontalAlign: 'center',
              timeout: 2000
            })
            this.errormessage = error
          })
      }
    },
    updateTabValues: function (t) {
      // Setting up this property reactively was a pain.
      // Don't judge me.
      this.goal0ToolTip = this.statuses[t.TicketGoals[0].TicketGoalStatus].badgeToolTip
      this.goal0BadgeClass = this.statuses[t.TicketGoals[0].TicketGoalStatus].badgeClass
      this.goal0Badge = this.statuses[t.TicketGoals[0].TicketGoalStatus].badge
      this.goal0GoalName = t.TicketGoals[0].GoalName

      this.goal1ToolTip = this.statuses[t.TicketGoals[1].TicketGoalStatus].badgeToolTip
      this.goal1BadgeClass = this.statuses[t.TicketGoals[1].TicketGoalStatus].badgeClass
      this.goal1Badge = this.statuses[t.TicketGoals[1].TicketGoalStatus].badge
      this.goal1GoalName = t.TicketGoals[1].GoalName

      this.goal2ToolTip = this.statuses[t.TicketGoals[2].TicketGoalStatus].badgeToolTip
      this.goal2BadgeClass = this.statuses[t.TicketGoals[2].TicketGoalStatus].badgeClass
      this.goal2Badge = this.statuses[t.TicketGoals[2].TicketGoalStatus].badge
      this.goal2GoalName = t.TicketGoals[2].GoalName

      this.goal3ToolTip = this.statuses[t.TicketGoals[3].TicketGoalStatus].badgeToolTip
      this.goal3BadgeClass = this.statuses[t.TicketGoals[3].TicketGoalStatus].badgeClass
      this.goal3Badge = this.statuses[t.TicketGoals[3].TicketGoalStatus].badge
      this.goal3GoalName = t.TicketGoals[3].GoalName

      this.goal4ToolTip = this.statuses[t.TicketGoals[4].TicketGoalStatus].badgeToolTip
      this.goal4BadgeClass = this.statuses[t.TicketGoals[4].TicketGoalStatus].badgeClass
      this.goal4Badge = this.statuses[t.TicketGoals[4].TicketGoalStatus].badge
      this.goal4GoalName = t.TicketGoals[4].GoalName

      this.$nextTick(function () {
        this.$forceUpdate()
      })
    },
    returnPage: function () {
      this.$router.push(this.callingPage)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img {
  margin-right: 10px;
}
label {
  margin-bottom: 0;
  margin-top: 0.5rem;
  padding-left: 0.3rem;
}
.mobileLabel {
  font-size: 0.8571em;
  margin-bottom: 5px;
  color: #9a9a9a;
}
.badge-new {
  font-size:10px;
  background:#66615B;
  border: 1px solid #66615B !important;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.badge-pend {
  font-size:10px;
  background:#66615B;
  border: 1px solid #66615B !important;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.badge-work {
  font-size:10px;
  background:#66615B;
  border: 1px solid #66615B !important;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.badge-done {
  font-size:10px;
  background:#6bf098;
  border: 1px solid #6bf098 !important;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
</style>
